/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * Model for storing search suggestions
 */
export class SearchSuggestionModel {
  /**
   * Recent searches for search query
   */
  public recentSearches: string[];
  /**
   * Popular searches for search query
   */
  public popularSearches: string[];
  /**
   * Category searches for search query
   */
  public categorySearches: string[];

  constructor(newSearchTerm: string, recentSearches: string[], searchSuggestions: string[]) {
    const maximumRecentSearches = 3;
    const maximimSuggestions = 6;

    const numberOfRecentSearches =
      recentSearches.length > maximumRecentSearches ? maximumRecentSearches : recentSearches.length;
    this.recentSearches = recentSearches.splice(0, numberOfRecentSearches);

    // Get category searches
    this.addCategorySearches(searchSuggestions);

    // We can have only certain number of searches, take remaining from searchSuggestions
    let numberOfSearchSuggestions = maximimSuggestions - numberOfRecentSearches;
    numberOfSearchSuggestions =
      numberOfSearchSuggestions > searchSuggestions.length
        ? searchSuggestions.length
        : numberOfSearchSuggestions;
    this.popularSearches = searchSuggestions.splice(0, numberOfSearchSuggestions);
  }

  private addCategorySearches(popularSearches: string[]): void {
    const mostPopularSearch = popularSearches.length > 0 ? popularSearches[0] : '';
    this.categorySearches = [];
    if (popularSearches.length > 0) {
      this.categorySearches.push(mostPopularSearch + ' in Devices');
      this.categorySearches.push(mostPopularSearch + ' in Accessories');
      this.categorySearches.push(mostPopularSearch + ' in Videos');
      this.categorySearches.push(mostPopularSearch + ' in Support');
    }
  }
}
